import React from 'react';
import { useDispatch } from 'react-redux';
import { Icon } from "rhombus-react";

import { openModal } from 'reducers/Modal';
import { MODAL_TYPES } from 'utils/constants';
import { tellSentry } from 'utils/Rave';

export default function VersionsImportSocketError(props) {
	const dispatch = useDispatch();

	const { clearMessage, timestamp, prettyTime, data = {} } = props;
	const libraryName = data?.creativeLibrary?.name || "Library";
	const { filename } = data?.request;
	const { error } = data?.response;

	function viewErrors() {
		let parsedErrors;
		// Putting this in a try block in case the error comes back in an unparseable way
		try {
			parsedErrors = JSON.parse(error);
			if (!Array.isArray(parsedErrors)) {
				throw new Error();
			}
		} catch (e) {
			parsedErrors = ["An unknown error has occurred"];
			tellSentry(`Expected error to be of type array. Received ${typeof error}`);
		}
		dispatch(
			openModal(MODAL_TYPES.IMPORT_VERSIONS_ERROR, { filename, errors: parsedErrors })
		);
	}

	return (
		<>
			<i
				key="status-icon"
				className="ft-ic status-icon error"
				title="Error"
			/>
			<div key="body" className="message-body">
				<div className="socket-error-message">
					<span>Error importing versions sheet:</span>
					<span title={filename} className="text-overflow filename">
						{filename}
					</span>
					<a href="#" onClick={viewErrors}>
						View Errors
					</a>
				</div>
			</div>
			<Icon
				key="clear"
				name="clear"
				iconStyle="fal"
				className="clear-message"
				title="Clear Message"
				onClick={clearMessage}
			/>
			<b key="empty" />
			<span
				key="footer"
				className="message-footer name-overflow"
				title={libraryName}
			>
				{libraryName}
			</span>
			<time key="time" className="message-time" dateTime={timestamp}>
				{prettyTime}
			</time>
		</>
	);
}
